export const ApiBaseUrl2 = "https://localhost:5001/";
export const ApiBaseUrl = "https://api1.khalidelewa.com/";
